import { UserSystemRoleModelPermissionMap } from '../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { ConnectionPage } from '../../mail/connectionPage/ConnectionPage';
import { MailAdminForm } from '../../mail/form/MailAdminForm';
import { ActiveDirectoryAdminTable } from '../../user/activeDirectory/table/ActiveDirectoryAdminTable';
import { ISettingsItem } from '../ISettingsItem';

export const IntegrationSettingsItem: ISettingsItem = {
  id: 'integration',
  settingsItem: {
    key: 'integration',
    title: 'settings.integrationsTitle',
    buttons: [
      {
        title: 'Active Directory',
        url: `/settings/activedirectory/server`,
        permissions: [UserSystemRoleModelPermissionMap['settings-integrations-read']],
      },
      {
        title: 'settings.mail',
        url: `/settings/mail/server`,
        permissions: [UserSystemRoleModelPermissionMap['settings-integrations-read']],
      },
    ],
    permissions: [UserSystemRoleModelPermissionMap['settings-integrations-read']],
    infoText: 'settings.integrationsDes',
    orderIndex: 800,
  },
  routers: [
    {
      key: 'integration-ad-list-settings',
      path: '/settings/activedirectory/server',
      pageTitle: 'phrases.activeDirectoryServers',
      component: ActiveDirectoryAdminTable,
      allowedPermissions: [UserSystemRoleModelPermissionMap['settings-integrations-read']],
    },
    {
      key: 'integration-mail-list-settings',
      path: '/settings/mail/server',
      pageTitle: 'Mail соединения',
      component: ConnectionPage,
      allowedPermissions: [UserSystemRoleModelPermissionMap['settings-integrations-read']],
    },
    {
      key: 'integration-mail-new-settings',
      path: '/settings/mail/server/new',
      pageTitle: 'Добавить соединение с Mail',
      component: MailAdminForm,
      allowedPermissions: [UserSystemRoleModelPermissionMap['settings-integrations-create']],
    },
    {
      key: 'integration-mail-edit-settings',
      path: '/settings/mail/server/:entityId/edit',
      pageTitle: 'Редактировать соединение с Mail',
      component: MailAdminForm,
      allowedPermissions: [UserSystemRoleModelPermissionMap['settings-integrations-update']],
    },
  ],
};
